module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Regular.a500c10a.woff2";